"use strict";

/* Controllers */

angular
    .module("BannerFlowApp")
    .controller("RootController", function RootController($state, $stateParams) {
        if ($stateParams.rootAccountId) {
            window.open("/v2/{0}".format($stateParams.rootAccountId), "_self");
            return;
        }
        $state.go("root");
    });
